var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"button",staticClass:"button is-dark is-small",attrs:{"data-clipboard-text":_vm.value}},[_c('i',{staticClass:"material-icons"},[_vm._v("")]),_c('span',[_vm._v(_vm._s(_vm.$t('ui.buttons.copy')))])])}
var staticRenderFns = []

export { render, staticRenderFns }